import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
	App as CapacitorApp,
	URLOpenListenerEvent,
	BackButtonListenerEvent,
} from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { isCapacitorPlatform, setCapacitorDeviceOrientation } from "./helpers";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import { PushNotificationsHandler } from "./push-notifications/PushNotificationsHandler";
import { redirect } from "@state";
import { DeviceDetector } from "@utils/common/DeviceDetector";

/**
 * if capacitor platform:
 * attach appurlopen listener - deep link integration,
 * on resume listener
 * attach back button listener - hardware back button,
 * removes splash screen
 * start new relic capacitor plugin
 * ip restriction
 */
export function useCapacitorPlatform() {
	let history = useHistory();
	const rootStore = App.state.rootStore;

	useEffect(() => {
		if (isCapacitorPlatform()) {
			//signal that App is ready
			CapacitorUpdater.notifyAppReady();

			CapacitorApp.addListener("resume", () => {
				rootStore.capacitorUpdaterStore.onInitialize();
				rootStore.checkIfIpRestricted();
				PushNotificationsHandler.initialize();
				PushNotificationsHandler.updateUserToken();

				rootStore.notificationSettingsStore.onAppResume();
			});

			CapacitorApp.addListener(
				"appUrlOpen",
				(event: URLOpenListenerEvent) => {
					const slug = event.url.split(WEBPACK_WEBSITE_URL).pop();

					if (slug) {
						history.push(slug);

						const searchParams = new URLSearchParams(
							location.search
						);
						if (searchParams.get("gotsso")) {
							//handle sso login on deep link redirect to app
							rootStore.userAuthStore.onInitialize();
						}
					}
				}
			);

			CapacitorApp.addListener(
				"backButton",
				(event: BackButtonListenerEvent) => {
					if (event.canGoBack) {
						history.goBack();
						return;
					}

					CapacitorApp.exitApp();
				}
			);

			setCapacitorDeviceOrientation("portrait");

			SplashScreen.hide();

			rootStore.capacitorUpdaterStore.onInitialize();

			PushNotificationsHandler.initialize();
		}
		return () => {
			CapacitorApp.removeAllListeners();
		};
	}, []);

	useEffect(() => {
		const handleXPEvent = (event: any) => {
			const data = event.detail;
			const rawUrl = data.url;

			try {
				const urlObject = new URL(rawUrl);

				const internalPath =
					urlObject.pathname + urlObject.search + urlObject.hash;

				redirect(internalPath);
			} catch (error) {
				console.error("Redirection Error:", error);
				redirect(rawUrl);
			}
		};

		if (DeviceDetector.isIOS) {
			return;
		}

		window.addEventListener("xp_deeplink", handleXPEvent);

		return () => window.removeEventListener("xp_deeplink", handleXPEvent);
	}, []);
}
